const Data = [
  [
    "VanillaJs",
    [
      [
        "Analog Clock",
        "https://cheery-marshmallow-b8f4ae.netlify.app/links/analogclock/",
        "Preview analogclock",
      ],
      [
        "Apple.com",
        "https://cheery-marshmallow-b8f4ae.netlify.app/links/apple-com/",
        "Preview apple",
      ],
      [
        "Atom.io",
        "https://cheery-marshmallow-b8f4ae.netlify.app/links/atomio/",
        "Preview atomio",
      ],
      [
        "Clock",
        "https://cheery-marshmallow-b8f4ae.netlify.app/links/clock/",
        "Preview clock",
      ],
      [
        "Timer",
        "https://cheery-marshmallow-b8f4ae.netlify.app/links/clockapp1/",
        "Preview timer",
      ],
      [
        "Dice-Game",
        "https://cheery-marshmallow-b8f4ae.netlify.app/links/dice-roll-main/",
        "Preview dice-game",
      ],
      [
        "Github-Clone",
        "https://cheery-marshmallow-b8f4ae.netlify.app/links/github-clone/",
        "Preview github",
      ],
      [
        "Insta-clone",
        "https://cheery-marshmallow-b8f4ae.netlify.app/links/instagram%20clone/",
        "Preview insta",
      ],
      [
        "News-App",
        "https://illustrious-cendol-f86b93.netlify.app/",
        "Preview news",
      ],
      [
        "NotePad",
        "https://cheery-marshmallow-b8f4ae.netlify.app/links/notepad/",
        "Preview notepad",
      ],
      [
        "Rock-Paper..",
        "https://cheery-marshmallow-b8f4ae.netlify.app/links/rockpaperscissors/",
        "Preview rock-paper",
      ],
      [
        "Spotify",
        "https://cheery-marshmallow-b8f4ae.netlify.app/links/spotify/",
        "Preview spotify",
      ],
      [
        "ToDo List",
        "https://cheery-marshmallow-b8f4ae.netlify.app/links/todolist/homepage",
        "Preview todolist-vanilla",
      ],
      [
        "VoiceRecog..",
        "https://cheery-marshmallow-b8f4ae.netlify.app/links/voicerecognition/",
        "Preview voice-rec",
      ],
      [
        "Weather-App",
        "https://chirag-weather.netlify.app/",
        "Preview weather-vanilla",
      ],
    ],
  ],

  [
    "ReactJs",
    [
      [
        "Search-Bar",
        "https://imaginative-bienenstitch-c19272.netlify.app/",
        "Preview search-bar",
      ],
      [
        "ToDo-App",
        "https://cool-dusk-893eee.netlify.app/",
        "Preview todolist-react",
      ],
      [
        "Restaurant-Menu",
        "https://comforting-cupcake-934ae3.netlify.app/",
        "Preview restaurant-app",
      ],
      [
        "Crypto-Tracker",
        "https://chirag-crypto-tracker.netlify.app/",
        "Preview crypto",
      ],
      ["Chat-App", "https://chirag-chat-app.netlify.app/", "Preview chat-app"],
      [
        "Todo-Complete",
        "https://chirag-todo.netlify.app/",
        "Preview todo-complete",
      ],
      [
        "Travelogue",
        "https://travelogue-hackathon.netlify.app/",
        "Preview travelogue",
      ],
      [
        "Sorting-Visualizer",
        "https://chirag-sorting-visualizer.netlify.app/",
        "Preview Sorting-Visualizer",
      ],
    ],
  ],

  [
    "NodeJs",
    [
      [
        "Automated Portfolio",
        "https://link-pro.netlify.app/",
        "Preview portfolio-generator",
      ],
    ],
  ],
];

const Titles = [];

for (let i = 0; i < Data.length; i++) {
  Titles.push(Data[i][0]);
}

export { Titles };
export default Data;
